/* eslint-disable @typescript-eslint/no-explicit-any */
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, } from '@chakra-ui/react';
import React, { createContext, useState, useContext } from 'react';
import { Guid } from 'guid-typescript';
const store = createContext({
    hideAllDrawers: () => undefined,
    hideDrawer: () => undefined,
    index: -1,
    setState: () => undefined,
    showDrawer: () => undefined,
    state: [],
});
const { Provider } = store;
export const InfiniteDrawerProvider = (props) => {
    const { children } = props;
    const [state, setState] = useState([]);
    const index = state.length - 1;
    const currentState = index >= 0 ? state[index] : undefined;
    const firstState = index >= 0 ? state[0] : undefined;
    const handleDrawerClose = (drawerProperties) => {
        // Copy State
        const nextState = state.concat();
        // Remove last item
        nextState.pop();
        // Update the state
        setState(nextState);
        if (drawerProperties.onClose) {
            drawerProperties.onClose();
        }
    };
    const hideAllDrawers = () => {
        state.forEach((drawerProperties) => {
            if (drawerProperties.onClose) {
                drawerProperties.onClose();
            }
        });
        setState([]);
    };
    const hideDrawer = () => handleDrawerClose(currentState);
    const showDrawer = (drawerProperties) => {
        // Add new drawer properties
        setState([...state, Object.assign(Object.assign({}, drawerProperties), { id: Guid.create().toString() })]);
    };
    return (React.createElement(Provider, { value: { hideAllDrawers, hideDrawer, index, showDrawer, setState, state } },
        React.createElement(Drawer, Object.assign({ autoFocus: false, closeOnOverlayClick: !(firstState === null || firstState === void 0 ? void 0 : firstState.disableCloseOnOverlayClick), isOpen: !!currentState, placement: "right", size: (firstState === null || firstState === void 0 ? void 0 : firstState.size) || 'md', onClose: hideDrawer }, firstState === null || firstState === void 0 ? void 0 : firstState.drawerProps),
            React.createElement(DrawerOverlay, Object.assign({}, firstState === null || firstState === void 0 ? void 0 : firstState.drawerOverlayProps), state.map((drawerProperties) => (React.createElement(DrawerContent, Object.assign({ borderBottomLeftRadius: 16, borderTopLeftRadius: 16, css: { transform: index > 0 ? 'none !important' : undefined }, key: drawerProperties.id }, drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.drawerContentProps),
                React.createElement(DrawerCloseButton, Object.assign({}, drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.drawerCloseButtonProps)),
                React.createElement(DrawerHeader, Object.assign({}, drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.drawerHeaderProps), (drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.header) || React.createElement(React.Fragment, null)),
                React.createElement(DrawerBody, Object.assign({}, drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.drawerBodyProps), (drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.body) || React.createElement(React.Fragment, null)),
                React.createElement(DrawerFooter, Object.assign({}, drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.drawerFooterProps), (drawerProperties === null || drawerProperties === void 0 ? void 0 : drawerProperties.footer) || React.createElement(React.Fragment, null))))))),
        children || React.createElement(React.Fragment, null)));
};
export function useInfiniteDrawer() {
    const { hideAllDrawers, hideDrawer, index, showDrawer } = useContext(store);
    return {
        hideAllDrawers,
        hideDrawer,
        index,
        showDrawer,
    };
}
//# sourceMappingURL=index.js.map